import colors from '../colors';
import vortexLogo from '../../images/vortex-logo.svg';

export default {
  brand: colors.vortex.brand,
  brandImage: vortexLogo,

  btnPrimaryBg: '#EFF0F1',
  btnPrimaryColor: colors.vortex.brand,

  btnSecondaryBg: '#E5E3E6',
  btnSecondaryColor: colors.vortex.brand,

  headerBg: colors.vortex.brand,

  sectionBg1: colors.vortex.bg1,
  sectionBg2: colors.vortex.bg2,

  submitButtonBg: colors.vortex.brand,
  submitButtonDisabledColor: '#874B89'
};



// WEBPACK FOOTER //
// ./src/config/themes/vortex.js